import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { TaskCardType1, TaskCardType2 } from '../utilities/models/task-card-model';

@Component({
	selector: 'app-task-card',
	templateUrl: './task-card.component.html',
	styleUrls: ['./task-card.component.scss']
})
export class TaskCardComponent implements OnInit {

	@Input() record: TaskCardType1 | TaskCardType2;
	@Output() actionEmit: any = new EventEmitter();

	recordData;

	constructor(
		public locale: LocaleService,
	) { }

	ngOnInit(): void {
		this.recordData = this.record;
	}

	actionClick(data) {
		if (navigator.onLine) {
			this.actionEmit.emit(data);
		}
	}

}
